"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerOrderUpdateSchema = exports.CustomerOrderUpdateScalarSchema = exports.CustomerOrderCreateSchema = exports.CustomerOrderCreateScalarSchema = exports.CustomerOrderPrismaUpdateSchema = exports.CustomerOrderPrismaCreateSchema = exports.CustomerOrderSchema = exports.CustomerOrderScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const OrderType_schema_1 = require("../enums/OrderType.schema");
const OrderStatus_schema_1 = require("../enums/OrderStatus.schema");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    stripePaymentIntentId: zod_1.z.string().nullish(),
    orderType: OrderType_schema_1.OrderTypeSchema,
    orderStatus: OrderStatus_schema_1.OrderStatusSchema,
    tipPercentage: zod_1.z.number().default(0),
    initiateCheckout: zod_1.z.boolean().default(false),
    tableNumber: zod_1.z.string().nullish(),
    receipt: zod_1.z.string().nullish(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
}).strict();
const relationSchema = zod_1.z.object({
    dishes: zod_1.z.array(zod_1.z.unknown()).optional(),
    coupons: zod_1.z.array(zod_1.z.unknown()).optional(),
    customer: zod_1.z.record(zod_1.z.unknown()),
    merchant: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    customerId: zod_1.z.string().uuid(),
    merchantId: zod_1.z.string().uuid(),
});
/**
 * `CustomerOrder` schema excluding foreign keys and relations.
 */
exports.CustomerOrderScalarSchema = baseSchema;
/**
 * `CustomerOrder` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.CustomerOrderSchema = exports.CustomerOrderScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.CustomerOrderPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.CustomerOrderPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    stripePaymentIntentId: zod_1.z.string().nullish(),
    orderType: OrderType_schema_1.OrderTypeSchema,
    orderStatus: OrderStatus_schema_1.OrderStatusSchema,
    tipPercentage: zod_1.z.union([zod_1.z.number().default(0), zod_1.z.record(zod_1.z.unknown())]),
    initiateCheckout: zod_1.z.boolean().default(false),
    tableNumber: zod_1.z.string().nullish(),
    receipt: zod_1.z.string().nullish(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date())
}).partial().passthrough();
/**
 * `CustomerOrder` schema for create operations excluding foreign keys and relations.
 */
exports.CustomerOrderCreateScalarSchema = baseSchema.partial({
    orderType: true, orderStatus: true, tipPercentage: true, initiateCheckout: true, createdAt: true, updatedAt: true
});
/**
 * `CustomerOrder` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.CustomerOrderCreateSchema = exports.CustomerOrderCreateScalarSchema.merge(fkSchema);
/**
 * `CustomerOrder` schema for update operations excluding foreign keys and relations.
 */
exports.CustomerOrderUpdateScalarSchema = baseSchema.partial();
/**
 * `CustomerOrder` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.CustomerOrderUpdateSchema = exports.CustomerOrderUpdateScalarSchema.merge(fkSchema.partial());
